<template>
  <div
    class="main-steps"
    style="height: 300px;">
    <el-steps
      :active="step"
      direction="vertical">
      <el-step title="Sube la factura"/>
      <el-step title="Códigos de los boletos"/>
      <el-step title="Datos del cliente"/>
      <el-step title="Confirma los datos"/>
    </el-steps>
  </div>
</template>

<script>
export default {
  name: 'AppSteps',
  props: {
    step: {
      type: Number,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/_shared/main-steps.vue